var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isHeader)?_c('Header'):_vm._e(),_c('router-view'),(_vm.isFooter)?_c('Footer'):_vm._e(),(_vm.isContact)?_c('Contact',{attrs:{"visible":_vm.isContact},on:{"update:visible":function($event){_vm.isContact=$event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }